import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "info--sprite",
  "use": "info--sprite-usage",
  "viewBox": "0 0 34 34",
  "content": "<symbol viewBox=\"0 0 34 34\" id=\"info--sprite\">\n<circle cx=\"16.5024\" cy=\"16.5024\" r=\"16.5024\" />\n<path d=\"M17.6664 10.1269C17.6664 9.40785 17.0597 8.80116 16.3407 8.80116C15.6216 8.80116 15.0374 9.40785 15.0374 10.1269C15.0374 10.8459 15.6216 11.4301 16.3407 11.4301C17.0597 11.4301 17.6664 10.8459 17.6664 10.1269ZM15.3969 13.5872V23.6088L15.6216 23.8335H17.0597L17.2844 23.6088V13.5872L17.0597 13.3625H15.6216L15.3969 13.5872Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol